// Module
var code = `<ul class="importer-upload-criteria" style="width:400px"> <li> Make sure all the following required columns are filled in:<br/> <ul class="criteria-field-list"> <li>Location ID</li> <li>Location Name</li> <li>Address</li> <li>City</li> <li>State/Province</li> <li>Postal Code</li> <li>Country</li> </ul> </li> </ul> `;
// Exports
module.exports = code;